/** Configuración visual y de contacto de la tienda pública */
export const SITE = {
  name: '¡Oh! Belleza',
  tagline: 'Productos de belleza importados con registro INVIMA',
  email: 'ohbelleza@yahoo.com.co',
  contactEmail: 'ohbelleza@yahoo.com.co',
  phones: ['3147526660'],
  whatsapp: '573147526660',
  address: 'Carrera 47 #50-23, Edificio Escobar Saldarriaga, Medellín',
  addressShort: 'Carrera 47 #50-23 Edificio Escobar Saldarriaga',
  hours: 'L·M·J·V 8:30–12:30 y 1:30–6:00 · Mié 8:30–12:30 y 2:00–6:00 · Sáb cerrado',
  hoursLines: [
    'Lunes, martes, jueves y viernes: 8:30–12:30 y 1:30–6:00',
    'Miércoles: 8:30–12:30 y 2:00–6:00',
    'Sábado: cerrado',
  ],
  handle: '@ohbellezamedellin',
  social: {
    instagram: 'https://www.instagram.com/ohbellezamedellin/',
    facebook: 'https://www.facebook.com/ohbellezamedellin/',
    tiktok: 'https://www.tiktok.com/@ohbellezamedellin',
  },
  banners: [
    { title: 'UÑAS', subtitle: 'MANICURE Y PEDICURE', cta: 'Ver uñas', category: 'UÑAS' },
    { title: 'ESMALTES', subtitle: 'COLORES QUE ENAMORAN', cta: 'Ver esmaltes', category: 'ESMALTES' },
    { title: 'BRILLOS', subtitle: 'BRILLA CON TU ESTILO', cta: 'Ver brillos', category: 'BRILLOS Y SOMBRAS' },
    { title: 'FACIAL', subtitle: 'CUIDADO PARA TU PIEL', cta: 'Ver facial', category: 'FACIAL Y CORPORAL' },
  ],
  collections: [
    { label: 'Uñas', category: 'UÑAS', href: '/catalogo-unas' },
    { label: 'Esmaltes', category: 'ESMALTES' },
    { label: 'Brillos y sombras', category: 'BRILLOS Y SOMBRAS' },
    { label: 'Facial y corporal', category: 'FACIAL Y CORPORAL' },
    { label: 'Brochas y pinceles', category: 'BROCHAS Y PINCELES' },
    { label: 'Pestañas', category: 'PESTAÑAS' },
    { label: 'Eléctricos', category: 'ELECTRICOS' },
    { label: 'Accesorios', category: 'ASESORIOS' },
  ],
};
